__turbopack_context__.v({
  "aboutBanner": "filters-module__OpdJJW__aboutBanner",
  "category": "filters-module__OpdJJW__category",
  "categoryOptions": "filters-module__OpdJJW__categoryOptions",
  "certificationSelect": "filters-module__OpdJJW__certificationSelect",
  "clearAllFilters": "filters-module__OpdJJW__clearAllFilters",
  "clearAllFiltersButton": "filters-module__OpdJJW__clearAllFiltersButton",
  "continent": "filters-module__OpdJJW__continent",
  "country": "filters-module__OpdJJW__country",
  "filterHeader": "filters-module__OpdJJW__filterHeader",
  "filters": "filters-module__OpdJJW__filters",
  "locationFilter": "filters-module__OpdJJW__locationFilter",
  "locationSelectOptions": "filters-module__OpdJJW__locationSelectOptions",
  "locationSelectOptionsIndent": "filters-module__OpdJJW__locationSelectOptionsIndent",
  "locationsOptions": "filters-module__OpdJJW__locationsOptions",
  "locationsSelectWrapper": "filters-module__OpdJJW__locationsSelectWrapper",
  "metalsSelect": "filters-module__OpdJJW__metalsSelect",
  "minus": "filters-module__OpdJJW__minus",
  "plus": "filters-module__OpdJJW__plus",
  "root": "filters-module__OpdJJW__root",
  "selectBoxCheck": "filters-module__OpdJJW__selectBoxCheck",
  "selectBoxExpand": "filters-module__OpdJJW__selectBoxExpand",
  "subLocationWrapper": "filters-module__OpdJJW__subLocationWrapper",
});
